var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveClientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6431 21.7571C18.6431 20.1658 18.0109 18.6397 16.8857 17.5144C15.7605 16.3892 14.2344 15.7571 12.6431 15.7571C11.0518 15.7571 9.52564 16.3892 8.40043 17.5144C7.27521 18.6397 6.64307 20.1658 6.64307 21.7571",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6431 15.7571C14.8522 15.7571 16.6431 13.9662 16.6431 11.7571C16.6431 9.54794 14.8522 7.75708 12.6431 7.75708C10.4339 7.75708 8.64307 9.54794 8.64307 11.7571C8.64307 13.9662 10.4339 15.7571 12.6431 15.7571Z",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6431 3.75708H5.64307C4.5385 3.75708 3.64307 4.65251 3.64307 5.75708V19.7571C3.64307 20.8617 4.5385 21.7571 5.64307 21.7571H19.6431C20.7476 21.7571 21.6431 20.8617 21.6431 19.7571V5.75708C21.6431 4.65251 20.7476 3.75708 19.6431 3.75708Z",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveClientIcon);
export default __webpack_public_path__ + "static/media/active-client-icon.75c15670c922bcd35712b7fff3ee6b4c.svg";
export { ForwardRef as ReactComponent };